import React, { useEffect } from 'react';
import { Loading as Spinner } from '@hyphengroup/cag-components';
import {
  getLoginRedirectUrl, setIsRedirectedFromPopup, removeLoginRedirectUrl,
  setLoginRedirectUrlFromParentWindow, removeLoginRedirectUrlFromParentWindow,
} from 'helpers/Utils';
import qs from 'query-string';
import { shape } from 'prop-types';

function Loading({ history }) {
  useEffect(() => {
    const { location: { search } } = history;
    const searchParams = qs.parse(search);

    const loginRedirectUrlFromSessionStorage = getLoginRedirectUrl();
    const loginRedirectUrlFromQueryParams = searchParams?.redirect;
    const loginRedirectUrl = loginRedirectUrlFromQueryParams || loginRedirectUrlFromSessionStorage;

    if (loginRedirectUrl) {
      removeLoginRedirectUrl();
      removeLoginRedirectUrlFromParentWindow();
      if (
        window.top.opener // Not iOS in-app
        && window.top.opener.location !== window.location // Not Andorid in-app as well
      ) {
        // Browsers support popup
        // Wait for its parent to close it
        if (loginRedirectUrlFromQueryParams) {
          setLoginRedirectUrlFromParentWindow(loginRedirectUrlFromQueryParams);
        }
      } else {
        // Browsers do not support popup such as Facebook in-app
        // The popup is loaded as a normal page so redirect itself
        setIsRedirectedFromPopup(true);
        window.location.href = loginRedirectUrl;
      }
    } else {
      // Direct access to the page
      window.self.close();
    }
  }, []);
  return (<Spinner />);
}

Loading.propTypes = {
  history: shape({}).isRequired,
};

export default Loading;
